import { Injectable } from '@angular/core';
import {
  NumberSymbol,
  registerLocaleData,
  NumberFormatStyle
} from '@angular/common';

import directLocale from '@angular/common/locales/en';

// constants from Angular i18n
const DIGIT_CHAR = '#';
const DECIMAL_SEP = '.';
const GROUP_SEP = ',';
const PATTERN_SEP = ';';
const ZERO_CHAR = '0';

/**
 * Serve custom locale with rules, defined by backend config
 * Should be used on root scope only
 */
@Injectable({
  providedIn: 'root',
})
export class DirectLocaleService {

  private currencyFormat: string;
  private fractionFormat: string;
  private localeData: any;

  public LocaleDataIndex = {
    LocaleId: 0,
    NumberSymbols: 13,
    NumberFormats: 14,
  };

  constructor() {
    directLocale[this.LocaleDataIndex.LocaleId] = 'direct';
    this.localeData = directLocale;
    registerLocaleData(directLocale);
  }

  /**
   * Replace locale parameters found in price format
   */
  updateCurrencyFormat(format: string) {
    if (format === this.currencyFormat) {
      return;
    }
    this.currencyFormat = format;
    const decimalMatch = format.match(
      new RegExp(`[${DIGIT_CHAR}${ZERO_CHAR}]([^${DIGIT_CHAR}])${ZERO_CHAR}`)
    );
    const groupMatch = format.match(
      new RegExp(`${DIGIT_CHAR}([^${DIGIT_CHAR}])${DIGIT_CHAR}`)
    );
    if (!groupMatch || !groupMatch.length) {
      console.error('Bad price format');
      return;
    }
    if (decimalMatch) {
      this.localeData[this.LocaleDataIndex.NumberSymbols][NumberSymbol.Decimal] =
        decimalMatch[1];
      format = format.replace(decimalMatch[1], DECIMAL_SEP);
    }
    if (groupMatch) {
      this.localeData[this.LocaleDataIndex.NumberSymbols][NumberSymbol.Group] =
        groupMatch[1];
      format = format.replace(groupMatch[1], GROUP_SEP);
    }
    this.localeData[this.LocaleDataIndex.NumberFormats][
      NumberFormatStyle.Currency
    ] = format;
    registerLocaleData(this.localeData);
    this.updateFractionFormat(format);
  }

  /**
   * Used as pipe parameter
   * to revert Angular overrides by i18n config for currencies
   */
  getFractionFormat() {
    return this.fractionFormat;
  }

  /**
   * Fraction parsing
   * as it's in Angular func formatNumberToLocaleString
   */
  private updateFractionFormat(format: string) {
    let minFrac = 0;
    let maxFrac = 0;

    const patternParts = format.split(PATTERN_SEP);
    const positive = patternParts[0];

    const positiveParts =
        positive.indexOf(DECIMAL_SEP) !== -1
          ? positive.split(DECIMAL_SEP)
          : [
              positive.substring(0, positive.lastIndexOf(ZERO_CHAR) + 1),
              positive.substring(positive.lastIndexOf(ZERO_CHAR) + 1),
            ],
      fraction = positiveParts[1] || '';

    for (let i = 0; i < fraction.length; i++) {
      const ch = fraction.charAt(i);
      if (ch === ZERO_CHAR) {
        minFrac = maxFrac = i + 1;
      } else if (ch === DIGIT_CHAR) {
        maxFrac = i + 1;
      }
    }
    this.fractionFormat = `1.${minFrac}-${maxFrac}`;
  }
}
